export const nlsAnalyticsTabs = {
  'category-2-queries': {
    title: 'Category 2 queries',
  },
  'category-3-queries': {
    title: 'Category 3 queries',
  },
} as const;

export type NlsAnalyticsTab = keyof typeof nlsAnalyticsTabs;
export const nlsAnalyticsTabsList = Object.keys(nlsAnalyticsTabs) as Array<NlsAnalyticsTab>;
